module.exports = __webpack_public_path__ + "img/deans-lister2019-2020-3rd-term.ad38a07c.png";